import { render, staticRenderFns } from "./tipsfileUpload.vue?vue&type=template&id=d9a36646"
import script from "./tipsfileUpload.vue?vue&type=script&lang=js"
export * from "./tipsfileUpload.vue?vue&type=script&lang=js"
import style0 from "./tipsfileUpload.vue?vue&type=style&index=0&id=d9a36646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports